import { create } from 'zustand';
import { IRevisionExercises } from '../model';

interface IPracticeRevisionExercisesState {
  revisionExercises: IRevisionExercises | null;
  setRevisionExercises: (exercises: IRevisionExercises | null) => void;
}

export const practiceRevisionExercisesStore =
  create<IPracticeRevisionExercisesState>((set) => ({
    revisionExercises: null,
    setRevisionExercises: (exercises: IRevisionExercises | null) =>
      set({ revisionExercises: exercises }),
  }));
